export { Usuario } from './usuario';
export { Entry } from './entry';
export { Campus } from './campus';
export { Periodo } from './periodo';
export { Nivel } from './nivel';
export { CampaignDTO } from './campaignDTO';
export { Campaign } from './campaigns';
export { InfoPrograma } from './infoPrograma';
export { Alumno } from './inscripcion'
